import { NavCapability, SettingsNavItem, SettingsNavSection } from 'src/config/settingsNav';

export const STOREFRONT_ROOT = '/storefront';

/**
 * The storefront area's left nav.
 *
 * Deliberately a single section, unlike /settings' six: the area is small enough that grouping
 * would add a level of nesting without adding information. It still uses the same
 * section/item shape so it renders through the same components and the same capability
 * filtering — the point of the config is that the area is not a special case.
 *
 * Every section declares `canManageRestaurantSettings` (`isOwner || isPlatformAdmin`). An org
 * admin manages the restaurant day to day but does not manage its public website; a platform
 * admin does, deliberately, because that is how Restavo staff support a customer's site.
 */
export const storefrontNav: SettingsNavSection[] = [
  {
    key: 'site',
    labelKey: 'storefrontNav.site.title',
    capability: 'canManageRestaurantSettings',
    items: [
      { path: '/storefront', labelKey: 'storefrontNav.site.site' },
      { path: '/storefront/appearance', labelKey: 'storefrontNav.site.appearance' },
      { path: '/storefront/content', labelKey: 'storefrontNav.site.content' },
      { path: '/storefront/sections', labelKey: 'storefrontNav.site.sections' },
      { path: '/storefront/extras', labelKey: 'storefrontNav.site.extras' },
      { path: '/storefront/seo', labelKey: 'storefrontNav.site.seo' },
      { path: '/storefront/ordering', labelKey: 'storefrontNav.site.ordering' },
      { path: '/storefront/analytics', labelKey: 'storefrontNav.site.analytics' },
      { path: '/storefront/news', labelKey: 'storefrontNav.site.news' },
      { path: '/storefront/messages', labelKey: 'storefrontNav.site.messages' },
    ],
  },
];

export type { NavCapability, SettingsNavItem, SettingsNavSection };
